module.exports = __webpack_public_path__ + "static/media/02.ae564e13.png";